// Gesetzliche Feiertage Baden-Württemberg.
// Osterdatum nach Gauß (gregorianisch).

function easterSunday(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(d: Date, days: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + days);
  return r;
}

function isoKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

const cache = new Map<number, Set<string>>();

function holidaysForYear(year: number): Set<string> {
  const cached = cache.get(year);
  if (cached) return cached;
  const easter = easterSunday(year);
  const dates: Date[] = [
    new Date(year, 0, 1),       // Neujahr
    new Date(year, 0, 6),       // Hl. Drei Könige
    addDays(easter, -2),        // Karfreitag
    addDays(easter, 1),         // Ostermontag
    new Date(year, 4, 1),       // Tag der Arbeit
    addDays(easter, 39),        // Christi Himmelfahrt
    addDays(easter, 50),        // Pfingstmontag
    addDays(easter, 60),        // Fronleichnam
    new Date(year, 9, 3),       // Tag der Deutschen Einheit
    new Date(year, 10, 1),      // Allerheiligen
    new Date(year, 11, 25),     // 1. Weihnachtstag
    new Date(year, 11, 26),     // 2. Weihnachtstag
  ];
  const set = new Set(dates.map(isoKey));
  cache.set(year, set);
  return set;
}

export function isHolidayBW(date: Date): boolean {
  return holidaysForYear(date.getFullYear()).has(isoKey(date));
}

export function isWeekendOrHolidayBW(date: Date): boolean {
  const dow = date.getDay(); // 0=Sun, 5=Fri, 6=Sat
  if (dow === 0 || dow === 5 || dow === 6) return true;
  return isHolidayBW(date);
}
